var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTwoFactorComplete = function SvgIconTwoFactorComplete(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    fill: "none",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#74FF72",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M66.25 40.5c0 21.094-28.125 30.469-28.125 30.469S10 61.594 10 40.5V10.031L38.125 3l28.125 7.031V40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#74FF72",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M25.234 35.812l9.375 9.375 18.75-21.875"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTwoFactorComplete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-two-factor-complete.72fcb8ed12b3fae7547c3b7610d1983a.svg";